/**
 * Authoritative physical-nine pars and combo-course layouts.
 * Keep in sync with bag-tag-seed-courses.sql (holes 1–9 of each combo = front nine, etc.).
 */

export type NineName = 'blue' | 'red' | 'white';

/** Par per hole (1–9) for each physical nine at ANCC. */
export const PHYSICAL_NINE_PARS: Record<string, readonly number[]> = {
  'arl-blue': [4, 3, 4, 3, 4, 4, 4, 4, 5],
  'arl-red': [4, 4, 4, 5, 4, 3, 4, 3, 4],
  'arl-white': [4, 4, 3, 5, 4, 4, 5, 4, 3],
  'ffx-blue': [4, 4, 3, 5, 3, 5, 4, 4, 4],
  'ffx-red': [4, 4, 4, 3, 4, 5, 5, 3, 4],
  'ffx-white': [4, 3, 5, 5, 3, 4, 4, 4, 4],
} as const;

/** Combo slug → [front nine, back nine] physical names. */
export const COMBO_NINES: Record<string, readonly [NineName, NineName]> = {
  'arl-br': ['blue', 'red'],
  'arl-rw': ['red', 'white'],
  'arl-wb': ['white', 'blue'],
  'ffx-br': ['blue', 'red'],
  'ffx-rw': ['red', 'white'],
  'ffx-wb': ['white', 'blue'],
} as const;

export const COMBO_COURSE_SLUGS = Object.keys(COMBO_NINES);
